import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-generic-message-popup',
  templateUrl: './generic-message-popup.component.html',
  styleUrls: ['./generic-message-popup.component.scss']
})
export class GenericMessagePopupComponent implements OnInit {
  message: string = ""
  cancelButtonText = "OK"
  cancelButton = "cancel"
  RateValues:string;
  selectedReason: string = ""; 
  selectedDrivers: any[] = []; 
  IsSelected: boolean;
  selectedVehicles: any[] = [];
  


  formattedMessage: string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<GenericMessagePopupComponent>) {
      if (data) {
        this.message = data.message || this.message;
        if (data.formatMessage) {
          this.formattedMessage = this.formatMessage(this.message);
        } else {
          this.formattedMessage = '';
        }

        if (data.buttonText) {
            this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
        if (data.showDropdown) {
            this.selectedReason = data.selectedValue || "";
        }
        if (data.showDriverDropdown) {
          this.selectedDrivers = data.selectedValue || [];
        }
        if(data.showVehicleDropdown)
        {
          this.selectedVehicles = data.selectedValue || [];
        }

        const widthValue = data.width || '400vw';
        const heightValue = data.height || '400vw';
        this.dialogRef.updateSize(widthValue, heightValue);
    }
  }

  formatMessage(rawMessage: string): string {
    if(!rawMessage) return rawMessage;

    // maintain line breaks if already present and improve readability for long validators
    const separators = [':', ',', ';'];
    let formatted = rawMessage;

    // common trip import message keys to split by row/field/column/error
    formatted = formatted.replace(/\s*Row Number\s*:/gi, '\nRow Number:');
    formatted = formatted.replace(/\s*Field Name\s*:/gi, '\nField Name:');
    formatted = formatted.replace(/\s*Column\s*:/gi, '\nColumn:');
    formatted = formatted.replace(/\s*Invalid Value\s*:/gi, '\nInvalid Value:');
    formatted = formatted.replace(/\s*Error\s*:/gi, '\nError:');

    // fallback keep paragraphs and line wrap
    if (formatted === rawMessage) {
      formatted = formatted.replace(/\s*\|\s*/g, '\n');
    }

    return formatted;
  }

  ngOnInit() {
    if(this.RateValues!=null ||this.RateValues!=undefined)
    document.getElementById("UserAddedData").innerHTML=(this.RateValues);
  }

  onConfirmClick(): void {
    if (this.data.showDropdown) {
      this.dialogRef.close(this.selectedReason);
    }
    else if(this.data.showDriverDropdown)
    {
      this.dialogRef.close(this.selectedDrivers)
    }
    else if(this.data.showVehicleDropdown)
      {
        this.dialogRef.close(this.selectedVehicles)
      }
     else {
      this.dialogRef.close(true);
    }
  }
  // onConfirmDriverClick(): void {
  //   if (this.data.showDriverDropdown) {
  //     const selectedIds = this.selectedDrivers.map((d: any) => d.value);
  //     const flag = selectedIds.length > 0; 
  
  //     this.dialogRef.close({
  //       driverIds: selectedIds,
  //       flag: flag
  //     });
  //   } else {
  //     this.dialogRef.close(true);
  //   }
  // }
  
  onCancel()
  {
    this.dialogRef.close();
  }

}
